export default __webpack_public_path__ + "static/media/bartone.6db29d37.svg";